exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".language_treeview[data-v-5220e94e]{height:calc(100vh - 30px);background:#454d66;overflow-y:auto}.menu_ctrl[data-v-5220e94e]{display:flex;align-items:center;justify-content:space-between;background:var(--base-gray-darken);padding:3px;touch-action:none}.text[data-v-5220e94e]{color:#b3b7c4}", ""]);

